/** Convierte un periodo ISO al formato año-mes. */
export function periodToMonth(period: any): string {
  if (!period) return '';
  return String(period).split('T')[0].slice(0, 7);
}

/** Resuelve el periodo activo desde el periodo o el seleccionado. */
function resolveActive(period: any, selected: any): any {
  return period || selected;
}

/** Indica si el periodo activo carece de fecha. */
function hasNoActivePeriod(active: any): boolean {
  return !active?.period;
}

/** Resuelve el mes visible desde el periodo activo o el respaldo. */
export function currentMonth(period: any, selected: any, fallback: string): string {
  const active = resolveActive(period, selected);
  if (hasNoActivePeriod(active)) return fallback;
  return periodToMonth(active.period);
}

/** Obtiene el mes de un item de periodo. */
export function monthOfPeriod(item: any): string {
  return periodToMonth(item?.period);
}

/** Indica si el periodo está bloqueado para edición. */
export function isPeriodLocked(period: any): boolean {
  if (!period) return false;
  return lockReason(period);
}

/** Revisa las causas de bloqueo del periodo. */
function lockReason(period: any): boolean {
  if (period.realized) return true;
  return manuallyLocked(period);
}

/** Revisa el bloqueo manual o por vencimiento. */
function manuallyLocked(period: any): boolean {
  if (period.enabled === false) return true;
  return expiredLocked(period);
}

/** Indica si el periodo venció según su expiración. */
function expiredLocked(period: any): boolean {
  if (!period.expiration) return false;
  return new Date(period.expiration).getTime() < Date.now();
}

/** Busca un periodo por su mes en formato año-mes. */
export function findPeriodByMonth(periods: any[], month: string): any {
  for (const item of (periods || [])) {
    if (monthOfPeriod(item) === month) return item;
  }
  return null;
}

/** Busca el periodo cargado que coincide con la fecha. */
export function findMatchingPeriod(periods: any[], period: any): any {
  if (!period) return null;
  return matchByDate(periods, period.period);
}

/** Busca un periodo por igualdad de su fecha. */
function matchByDate(periods: any[], date: any): any {
  for (const item of (periods || [])) {
    if (String(item.period) === String(date)) return item;
  }
  return null;
}

/** Indica si la lista ya contiene el periodo indicado. */
export function containsPeriodId(periods: any[], id: string): boolean {
  for (const item of (periods || [])) {
    if (item.id === id) return true;
  }
  return false;
}
